/* global G */
import { curry } from 'lib/util'
import routeComposition from 'trait/composition/route'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'

/**
 * Redirects to a new route with the current serviceItem.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>} void
 */
// eslint-disable-next-line no-unused-vars
const createWithItem = async (module, component, event) => {
  const moduleState = module[G.STATE]
  const actionUi = moduleState[G.ACTION][G.UI]

  const { route = {} } = actionUi.create || {}
  moduleState[G.ROUTE] = routeComposition(route.module, route.action)

  const item = module[G.MODEL]
  const { product, installedAt } = item?.[G.CHILDREN] || {}

  await redirectSequence(module)({ item, product, installedAt })
}

export default curry(createWithItem)
